import React from 'react'
import { Grid, Typography } from '@material-ui/core/'
import './index.scss'

const MessageUser = ({ time, read, name, text }) => {
  return (
    <Grid className='messUserBox'>
      <Grid className='messageBox'>
        <Typography className='avatarUser'>{name}</Typography>
        <Grid className='textTimeMessage'>
          <Typography className='text'>{text}</Typography>
          <Typography className='time'>{time}</Typography>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default MessageUser
